import { render, staticRenderFns } from "./ExplorerFolderMenu.vue?vue&type=template&id=2b5c845a&"
import script from "./ExplorerFolderMenu.vue?vue&type=script&lang=js&"
export * from "./ExplorerFolderMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports